<template>
  <div>
    <div class="box box-content">
      <div class="box-left fl">
        <el-carousel trigger="click" height="367px" :autoplay="true">
          <el-carousel-item v-for="(item,index) in carouselList" :key="index">
            <div style="position:relative;height:100%;overflow: hidden;">
              <div class="title" style="position:absolute;bottom:0">{{item.title}}</div>
              <img
                :class="{issusor:item.newId?true:false}"
                :src="publicPath+item.homePageImage"
                alt
                style="width:100%;height:100%"
                @click="handelDeatil(item)"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="box-right fr">
        <div class="box-title">
          <div class="fl">
            <img
              src="../assets/images/news.png"
              width="32"
              height="25"
              style="vertical-align: middle"
            />
            <span
              style="color: #00ACD8;font-size: 17px;font-weight: 400;padding-left: 10px"
              class="m-title"
            >水保新闻</span>
          </div>
          <div class="fr m-more" @click="handelClick('notice')">更多></div>
        </div>
        <div class="clear"></div>
        <div class="box-info">
          <ul>
            <li
              class="m-item"
              v-for="(item,index) in newsList"
              :key="index"
              @click="turnDetail('new',item)"
            >
              <div>
                <div class="fl m-main" :title="item.title">
                  <div class="flag"></div>
                  {{item.title}}
                </div>
                <div class="fr m-time">{{item.publishTime | dateFormat}}</div>
              </div>
              <div class="clear"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <div class="box box-middle">
      <div style="display: inline-block;width: 70px;height: 100%;position: relative;float: left">
        <img
          style="position: absolute;top: 50%;margin-top: -20px;left: 50%; margin-left: -20px"
          src="../assets/images/broadcast.png"
          width="40"
          height="40"
        />
      </div>
      <div
        style="display: inline-block;width: 70px; height: 120px;line-height: 120px;float: left; font-size: 25px; color: white;font-weight: bolder"
        class="middle-title"
      >
        <span
          style="display: inline-block;vertical-align: middle;line-height: 35px;letter-spacing: 10px"
        >
          通知
          <br />公告
        </span>
      </div>
      <div style="float: left;width: 1px;height: 100%;background-color: white"></div>
      <div class="box-info" style="padding: 0 10px;float: left;width: 1000px">
        <ul style="height: 100%;color: white;padding: 8px 0">
          <li
            class="m-item"
            style="border-bottom: none;"
            v-for="(item,index) in noticeList.slice(0,3)"
            :key="index"
            @click="turnDetail('notice',item)"
          >
            <div class="middle-label">
              <div class="fl m-main" :title="item.title">{{item.title}}</div>
              <div class="fr m-time">{{item.publishTime | dateFormat}}</div>
            </div>
            <div class="clear"></div>
          </li>
        </ul>
        <div class="clear"></div>
      </div>
    </div>
    <div class="clear"></div>
    <div class="box box-wrapper">
      <div class="box-item fl">
        <div class="box-title">
          <div class="box-title-l fl">
            <span class="col-2"></span>
            <span class="col-1"></span>
            <span class="m-title">监督监测</span>
          </div>
          <div class="fr m-more" @click="handelClick('monitoring')">更多></div>
        </div>
        <li class="clear"></li>

        <div class="box-main">
          <ul>
            <li
              class="li-item"
              v-for="(supervision,index) in monitoringList"
              :key="index"
              @click="turnDetail('monitoring',supervision)"
            >
              <div class="fl m-main" :title="supervision.title">
                <div class="flag"></div>
                {{supervision.title}}
              </div>
              <div class="fr m-time">{{supervision.publishTime | dateFormat}}</div>
            </li>
            <li class="clear"></li>
          </ul>
        </div>
      </div>
      <div class="box-item fl">
        <div class="box-title">
          <div class="box-title-l fl">
            <span class="col-2"></span>
            <span class="col-1"></span>
            <span class="m-title">综合治理</span>
          </div>
          <div class="fr m-more" @click="handelClick('comprehensiveControl')">更多></div>
        </div>
        <li class="clear"></li>
        <div class="box-main">
          <ul>
            <li
              class="li-item"
              v-for="(comprehensive,index) in comprehensiveList"
              :key="index"
              @click="turnDetail('comprehensiveControl',comprehensive)"
            >
              <div class="fl m-main" :title="comprehensive.title">
                <div class="flag"></div>
                {{comprehensive.title}}
              </div>
              <div class="fr m-time">{{comprehensive.publishTime | dateFormat}}</div>
            </li>
            <li class="clear"></li>
          </ul>
        </div>
      </div>
      <div class="box-item fl">
        <div class="box-title">
          <div class="box-title-l fl">
            <span class="col-2"></span>
            <span class="col-1"></span>
            <span class="m-title">政策法规</span>
          </div>
          <div class="fr m-more" @click="handelClick('policiesAndRegulations')">更多></div>
        </div>
        <li class="clear"></li>
        <div class="box-main">
          <ul>
            <li
              class="li-item"
              v-for="(regulations,index) in regulationsList"
              :key="index"
              @click="turnDetail('policiesAndRegulations',regulations)"
            >
              <div class="fl m-main" :title="regulations.title">
                <div class="flag"></div>
                {{regulations.title}}
              </div>
              <div class="fr m-time">{{regulations.createTime | dateFormat}}</div>
            </li>
            <li class="clear"></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <!-- <div class="adv-warpper">
      <div class="box">
        <img class="w100 advImg" src="../assets/adv.png" alt />
      </div>
    </div>-->
    <!-- <div class="clear"></div> -->
    <!-- <div class="box box-wrapper">
      <div class="box-item fl">
        <div class="box-title">
          <div class="box-title-l fl">
            <span class="col-2"></span>
            <span class="col-1"></span>
            <span class="m-title">政策法规</span>
          </div>
          <div class="fr m-more" @click="handelClick('policiesAndRegulations')">更多></div>
        </div>
        <li class="clear"></li>
        <div class="box-main">
          <ul>
            <li class="li-item" v-for="(regulations,index) in regulationsList" :key="index" @click="turnDetail('policiesAndRegulations',regulations)">
              <div class="fl m-main" :title="regulations.title">
                <div class="flag"></div>{{regulations.title}}
              </div>
              <div class="fr m-time">{{regulations.createTime | dateFormat}}</div>
            </li>
            <li class="clear"></li>
          </ul>
        </div>
      </div>
      <div class="box-item fl">
        <div class="box-title">
          <div class="box-title-l fl">
            <span class="col-2"></span>
            <span class="col-1"></span>
            <span class="m-title">科普知识</span>
          </div>
          <div class="fr m-more" @click="handelClick('popularScienceKnowledge')">更多></div>
        </div>
        <li class="clear"></li>
        <div class="box-main">
          <ul>
            <li class="li-item" @click="turnDetail('popularScienceKnowledge',polularScience)" v-for="(polularScience,index) in polularScienceList" :key="index" >
              <div class="fl m-main" :title="polularScience.name">
                <div class="flag"></div>{{polularScience.name}}
              </div>
              <div class="fr m-time">{{polularScience.createTime | dateFormat}}</div>
            </li>
            <li class="clear"></li>
          </ul>
        </div>
      </div>
      <div class="box-item fl">
        <div class="box-title">
          <div class="box-title-l fl">
            <span class="col-2"></span>
            <span class="col-1"></span>
            <span class="m-title">信用管理</span>
          </div>
          <div class="fr m-more" @click="handelClick('creditManagement')">更多></div>
        </div>
        <li class="clear"></li>
        <div class="box-main">
          <img src="../assets/sy-xygl.png" style="width: 100%;    margin-top: 15px;" alt="" @click="handelClick('creditManagement')">
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import {
  getNewsPage,
  getHomePageNews,
  getListPolularScience,
  getNoticePage,
  getSupervisionPage,
  getComprehensivePage,
  getMonitoringPage,
  getRegulationsPage
} from "../api/index";
export default {
  name: "",
  data() {
    return {
      publicPath: window.publicPath,
      // 水保新闻
      newsList: [],
      noticeList: [],
      supervisionList: [],
      comprehensiveList: [],
      monitoringList: [],
      regulationsList: [],
      polularScienceList: [],
      carouselList: []
    };
  },
  created() {
    this.getNoticeList();
    this.getNewsHanlder();
    this.getSupervisionList();
    this.getComprehensiveList();
    this.getMonitoringList();
    this.getRegulationsPageList();
    this.getPolularScienceList();
    this.getCarouselList();
  },
  filters: {
    //将时间戳过滤为正常日期格式
    dateFormat: function (data) {
      if (!data) {
        return;
      }
      var date = new Date(data.replace(/-/g, "/")).Format("yyyy-MM-dd");
      return date;
    }
  },
  methods: {
    handelDeatil(item) {
      if (item.newId) {
        if (item.source == "0") {
          this.$router.push({
            path: "/newDetail/" + item.newId
          });
        } else {
          window.open(item.newId);
        }
      }
    },
    //查询水保新闻列表
    getNewsHanlder() {
      getNewsPage({
        current: 1,
        size: 8,
        title: ""
      }).then((res) => {
        this.newsList = res.data.records;
      });
    },
    getCarouselList() {
      getHomePageNews({}).then((res) => {
        this.carouselList = res.data;
      });
    },
    getPolularScienceList() {
      getListPolularScience({}).then((res) => {
        this.polularScienceList = [];
        res.data.some((item) => {
          if (this.polularScienceList.length < 6) {
            this.polularScienceList.push(item);
          }
        });
      });
    },
    getMonitoringList() {
      getMonitoringPage({
        size: 8
      }).then((res) => {
        this.monitoringList = res.data.records;
        console.log(res, "res=====");
      });
    },
    getNoticeList() {
      getNoticePage({
        size: 8
      }).then((res) => {
        this.noticeList = res.data.records;
        console.log(res, "res=====");
      });
    },
    getSupervisionList() {
      getSupervisionPage({
        size: 6
      }).then((res) => {
        this.supervisionList = res.data.records;
        console.log(res, "res=====");
      });
    },
    getComprehensiveList() {
      getComprehensivePage({
        size: 6
      }).then((res) => {
        this.comprehensiveList = res.data.records;
        console.log(res, "res=====");
      });
    },
    getRegulationsPageList() {
      getRegulationsPage({
        size: 6
      }).then((res) => {
        this.regulationsList = res.data.records;
        //this.regulationsList=this.regulationsList.reverse()
        console.log(res, "res=====");
      });
    },
    handelClick(rout) {
      this.$router.push("/" + rout + "Index");
    },
    turnDetail(rout, row) {
      this.$router.push({
        path: "/" + rout + "Detail/" + row.id,
        query: {
          openId: row.textType
        }
      });
      // this.$router.push('/'+rout+"Detail/"+row.id);
    }
  }
};
</script>

<style lang="" >
/* .el-carousel__item{
  position: relative;
} */
.el-carousel__indicators--horizontal {
  right: 20px;
  height: 40px;
  left: auto;
}
.el-carousel__item .title {
  height: 40px;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  line-height: 40px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  padding-left: 20px;
}
.el-carousel__button {
  width: 12px;
  height: 12px;
  background: rgba(133, 232, 255, 0.37);
  border-radius: 50%;
}
.el-carousel__indicator.is-active button {
  width: 22px;
  height: 12px;
  background: rgba(1, 173, 214, 1);
  border-radius: 6px;
}
.issusor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue